import React from 'react'
import { useTranslation } from 'react-i18next'
import type { LifeSpace } from '@/src/renderer/lib/db/models'
import './GoalsHelpPanel.scss'

interface GoalsHelpPanelProps {
  lifeSpace: LifeSpace
}

/**
 * Static help/context panel shown in the right sidebar on the Ziele page.
 *
 * Explains what goals are for. The copy is per-life-space — the framing
 * differs between Personal, Work and Home (Grilling #6). The panel title
 * ("Wozu Ziele da sind") is rendered by the RightSidebar header, not here.
 */
export const GoalsHelpPanel: React.FC<GoalsHelpPanelProps> = ({ lifeSpace }) => {
  const { t } = useTranslation()
  const base = `goals.help.${lifeSpace}`
  // `returnObjects` yields the array of paragraphs — but guard against a missing
  // or misconfigured key so a bad translation can't crash the panel via `.map`.
  const rawA = t(`${base}.bodyA`, { returnObjects: true })
  const rawB = t(`${base}.bodyB`, { returnObjects: true })
  const bodyA = Array.isArray(rawA) ? (rawA as string[]) : []
  const bodyB = Array.isArray(rawB) ? (rawB as string[]) : []

  return (
    <div className="goals-help">
      <section className="goals-help__section">
        <h4 className="goals-help__heading">{t(`${base}.headingA`)}</h4>
        {bodyA.map((paragraph, i) => (
          <p key={i} className="goals-help__text">{paragraph}</p>
        ))}
      </section>
      <section className="goals-help__section">
        <h4 className="goals-help__heading">{t(`${base}.headingB`)}</h4>
        {bodyB.map((paragraph, i) => (
          <p key={i} className="goals-help__text">{paragraph}</p>
        ))}
      </section>
    </div>
  )
}
